// This file is auto-generated from package.json
// To update the version, change it in package.json
import packageJson from '../../package.json';

export const APP_VERSION = packageJson.version;
